"use client";
import { useResponsive } from "@/app/hooks/useResponsive";
import { motion } from "framer-motion";
import Image from "next/image";
const Header = () => {
  const { isLg } = useResponsive();

  return (
    <motion.h2
      className="
				text-3xl sm:text-4xl md:text-5xl lg:text-6xl
				font-bold 
				text-primary-foreground 
				mb-6 
				flex flex-col sm:flex-row items-center justify-center gap-y-2 sm:gap-x-2
				text-center
  			"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.5 }}
    >
      <span className="md:mr-4 mr-0 text-nowrap">Sua jornada com a</span>
      <Image
        className="md:mt-2 h-auto w-auto"
        src="/escapa/transp/escapa_2.png"
        alt="Logo da escapa"
        width={isLg ? 220 : 120}
        height={0}
        style={{ height: "auto" }}
      />
    </motion.h2>
  );
};

export default Header;
